<template>
  <v-card class="mb-2">
    <v-card-title>{{ $t('account.home.personalData') }}</v-card-title>
    <v-card-text>
      <v-text-field
        :value="`${firstName} ${lastName}`"
        :label="$t('account.home.name')"
        readonly
      ></v-text-field>
      <v-text-field
        :value="email"
        :label="$t('account.home.email')"
        readonly
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn small color="primary" :to="{ name: 'account-personal' }">
        {{ $t('common.edit') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PersonalDataTeaser',
  computed: {
    ...mapState({
      firstName: (state) => state.user.firstName,
      lastName: (state) => state.user.lastName,
      email: (state) => state.user.email
    })
  }
}
</script>
